module.exports = __webpack_public_path__ + "img/animate2-22.52ec842f.png";